import { useEffect, useState } from 'react'

import useMetrics from '@/metrics/hooks/useMetrics/useMetrics'
import metricsServices from '@/metrics/services/services'

const useProductMetrics = ({ returnPortalId, setCommonFilters, commonFilters, position, groupBy, productsFilters }) => {
  const [product, setProduct] = useState()

  const { data: topReturnedProducts, loading: loadingTopReturnedProducts } = useMetrics({
    returnPortalId,
    service: metricsServices.getTopReturnedProducts,
    filters: commonFilters,
    additionalFilters: {
      groupBy,
      ordering: productsFilters?.ordering,
      query: productsFilters?.query,
    },
  })

  useEffect(() => {
    setProduct(topReturnedProducts?.results?.[position])
  }, [topReturnedProducts, position])

  const handleFiltersChange = filters => {
    setProduct(null)
    setCommonFilters(filters)
  }

  return {
    product,
    handleFiltersChange,
    loadingTopReturnedProducts,
  }
}

export default useProductMetrics
